import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalClosing() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-24 px-4 bg-teal text-white relative overflow-hidden text-center" data-id="element-112">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1515023115689-589c33041d3c?auto=format&fit=crop&q=80&w=1200')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-113"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-115">
          <h2 className="font-display italic font-bold text-2xl sm:text-3xl md:text-5xl mb-6 md:mb-8 leading-tight text-beige" data-id="element-116">
            "El momento de cambiar no es cuando todo esté perfecto.{' '}
            <span className="text-gold not-italic" data-id="element-117">
              Es ahora, que aún puedes elegir."
            </span>
          </h2>

          <div className="font-sans text-base md:text-xl text-beige/90 mb-8 md:mb-10 leading-relaxed font-light space-y-4" data-id="element-118">
            <p data-id="element-119">
              Llevas demasiado tiempo cargando sola. Tu cuerpo te ha estado
              pidiendo ayuda a su manera: con el cansancio, la ansiedad, la
              tensión. Hoy puedes responderle.
            </p>
            <p data-id="element-120">
              No necesitas más fuerza de voluntad. Necesitas el sistema
              correcto. Y hoy está disponible por solo{' '}
              <span className="text-gold font-bold text-2xl" data-id="element-121">$9,99</span>.
            </p>
          </div>

          <button onClick={scrollToCheckout} className="w-full sm:w-auto bg-gold hover:bg-gold-light text-teal-dark font-bold py-4 md:py-5 px-6 md:px-12 rounded-full transition-all text-sm md:text-xl mb-4 shadow-[0_6px_0_#B89A3E,0_8px_20px_rgba(201,168,76,0.4)] hover:shadow-[0_4px_0_#B89A3E,0_6px_16px_rgba(201,168,76,0.5)] hover:translate-y-[2px] active:translate-y-[4px] active:shadow-[0_2px_0_#B89A3E]" data-id="element-122">
            💚 SÍ, QUIERO RECUPERAR MI BIENESTAR HOY
          </button>

          <p className="text-sm text-beige/70 font-medium mt-4" data-id="element-123">
            Únete a +2.400 mujeres que ya eligieron su bienestar
          </p>
        </motion.div>
      </div>
    </section>;
}